var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2206 45.34L28.8825 43.9939L28.2206 45.34L40.3944 51.3259C42.9198 52.5677 45.8037 50.4724 45.4031 47.6869L43.4721 34.2592C43.45 34.1057 43.5004 33.9507 43.6084 33.8395L53.0633 24.1113C55.0247 22.0932 53.9231 18.703 51.1501 18.2232L37.7829 15.9103C37.6301 15.8839 37.4983 15.7881 37.4259 15.651L31.0956 3.65272C29.7823 1.16371 26.2177 1.1637 24.9044 3.65272L26.1452 4.30735L24.9044 3.65272L18.5741 15.651C18.5017 15.7881 18.3699 15.8839 18.2171 15.9103L4.84988 18.2232C2.07689 18.703 0.975331 22.0932 2.93672 24.1113L12.3916 33.8395C12.4996 33.9507 12.55 34.1057 12.5279 34.2592L10.5969 47.6869C10.1963 50.4724 13.0802 52.5677 15.6056 51.3259L27.7794 45.34C27.9185 45.2716 28.0815 45.2716 28.2206 45.34Z",
    fill: "#D9D9D9",
    stroke: "#58BCBE",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/emptyStar.93f610c432b5f5143b0a0e58808d82fa.svg";
export { ForwardRef as ReactComponent };